const STORAGE_KEY = 'applied-jobs'

interface AppliedEntry {
  jobId: string
  appliedAt: string
}

function getAppliedJobs(): AppliedEntry[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
  } catch {
    return []
  }
}

export function markJobAsApplied(jobId: string): void {
  const entries = getAppliedJobs()
  if (!entries.some(e => e.jobId === jobId)) {
    entries.push({ jobId, appliedAt: new Date().toISOString() })
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
  }
}

export function hasAppliedToJob(jobId: string): boolean {
  return getAppliedJobs().some(e => e.jobId === jobId)
}

export function getAppliedDate(jobId: string): string | null {
  const entry = getAppliedJobs().find(e => e.jobId === jobId)
  return entry?.appliedAt ?? null
}
